import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import {
      CardHeader,
      CardLinks,
      CardTitle,
} from "../../styles/components/common/Table";
import { LinkButton } from "../../styles/components/common/Button";
import FormInput from "../../components/form/FormInput";
import FormDescription from "../../components/form/FormDescription";
import FormStatusSelect from "../../components/form/FormStatusSelect";
import FormImage from "../../components/form/FormImage";
import FormButton from "../../components/form/FormButton";
import FormSeo from "../../components/common/FormSeo";
import { privateApi } from "../../api";

const ServiceEdit = () => {
      const { serviceId } = useParams();
      const navigate = useNavigate();
      const [loadingData, setLoadingData] = useState(false);

      const [loading, setLoading] = useState(false);
      const [image, setImage] = useState("");
      const [imageUrl, setImageUrl] = useState("");
      const [summary, setSummary] = useState("");
      const [title, setTitle] = useState("");
      const [slug, setSlug] = useState("");
      const [description, setDescription] = useState("");
      const [seoTitle, setSeoTitle] = useState("");
      const [seoKeyword, setSeoKeyword] = useState("");
      const [seoDescription, setSeoDescription] = useState("");
      const [status, setStatus] = useState("");


      const loadData = async () => {
            setLoadingData(true);

            await privateApi
                  .get(`/dashboard/services/${serviceId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setTitle(response.data.service.title);
                              setSlug(response.data.service.slug);
                              setSummary(response.data.service.summary);
                              setImageUrl(response.data.service.image);
                              setSeoTitle(response.data.service.seo_title);
                              setSeoKeyword(response.data.service.seo_keyword);
                              setDescription(response.data.service.description);
                              setSeoDescription(
                                    response.data.service.seo_description
                              );
                              setStatus(response.data.service.status);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            let updatedSlug = false;

            const handleUpdateSlug = () => {
                  if (updatedSlug) {
                        navigate(`/dashboard/services/${updatedSlug}/edit`);
                  }
            };

            const data = {
                  title: title,
                  slug: slug,
                  summary: summary,
                  status: status,
                  description: description,
                  image: image,
                  seo_title: seoTitle,
                  seo_description: seoDescription,
                  seo_keyword: seoKeyword,
            };

            await privateApi
                  .post(`/dashboard/services/${serviceId}`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                              updatedSlug = slug;
                              handleUpdateSlug();
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.slug) {
                                    toast.error(response.data.message.slug);
                              }
                              if (response.data.message.summary) {
                                    toast.error(response.data.message.summary);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                              if (response.data.message.description) {
                                    toast.error(
                                          response.data.message.description
                                    );
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.seo_title) {
                                    toast.error(
                                          response.data.message.seo_title
                                    );
                              }
                              if (response.data.message.seo_keyword) {
                                    toast.error(
                                          response.data.message.seo_keyword
                                    );
                              }
                              if (response.data.message.seo_description) {
                                    toast.error(
                                          response.data.message.seo_description
                                    );
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>
                                                      Edit Service
                                                </CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/services">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>

                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Service Title"
                                                            classes={7}
                                                            value={title}
                                                            required={true}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slug"
                                                            classes={5}
                                                            value={slug}
                                                            required={true}
                                                            handleChange={
                                                                  setSlug
                                                            }
                                                      />

                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <FormDescription
                                                      title="Summary"
                                                      required={true}
                                                      description={summary}
                                                      setDescription={
                                                            setSummary
                                                      }
                                                />
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <FormDescription
                                                      title="Description"
                                                      required={true}
                                                      description={description}
                                                      setDescription={
                                                            setDescription
                                                      }
                                                />
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <FormSeo
                                          setSeoDescription={setSeoDescription}
                                          setSeoTitle={setSeoTitle}
                                          setSeoKeyword={setSeoKeyword}
                                          description={seoDescription}
                                          keyword={seoKeyword}
                                          title={seoTitle}
                                    />
                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default ServiceEdit;
